import React from 'react';
import { ShieldCheck, Globe, CreditCard, Clock } from 'lucide-react';
import { motion } from 'framer-motion';
const badges = [{
  icon: Globe,
  text: 'UK-based',
  description: 'Proudly British service'
}, {
  icon: ShieldCheck,
  text: 'Secure Payments',
  description: 'Bank-grade security'
}, {
  icon: CreditCard,
  text: 'Clear Pricing',
  description: 'No hidden fees'
}, {
  icon: Clock,
  text: 'Reliable Access',
  description: '24/7 Availability'
}];
export function TrustBadges() {
  return <div className="w-full py-8" data-id="element-114">
      <div className="grid grid-cols-2 md:grid-cols-4 gap-6 max-w-4xl mx-auto" data-id="element-115">
        {badges.map((badge, index) => <motion.div key={badge.text} initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: index * 0.1,
        duration: 0.5
      }} className="flex flex-col items-center text-center p-4 rounded-lg bg-white/50 backdrop-blur-sm border border-slate-100 shadow-sm" data-id="element-116">
            <badge.icon className="w-8 h-8 text-primary mb-3" data-id="element-117" />
            <h3 className="font-semibold text-slate-dark text-sm mb-1" data-id="element-118">
              {badge.text}
            </h3>
            <p className="text-xs text-slate-light" data-id="element-119">{badge.description}</p>
          </motion.div>)}
      </div>
    </div>;
}